import { useState, useEffect } from 'react';
import { Tooltip, Typography } from 'antd';
import { WechatOutlined, CloseOutlined } from '@ant-design/icons';
import api from '@/api/client';

const { Text } = Typography;

interface WechatQrCodeProps {
  position?: 'left' | 'right';
}

export default function WechatQrCode({ position = 'left' }: WechatQrCodeProps) {
  const [groupQrCode, setGroupQrCode] = useState('');
  const [idQrCode, setIdQrCode] = useState('');
  const [expanded, setExpanded] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQrcodes = async () => {
      try {
        const res = await api.get('/auth/wechat-qrcodes');
        if (res.data.success) {
          setGroupQrCode(res.data.groupQrCode || '');
          setIdQrCode(res.data.idQrCode || '');
        }
      } catch {
        // 静默失败
      } finally {
        setLoading(false);
      }
    };
    fetchQrcodes();
  }, []);

  // 如果没有配置二维码，不显示组件
  if (!loading && !groupQrCode && !idQrCode) return null;

  return (
    <div
      style={{
        position: 'fixed',
        [position]: 20,
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 100,
        display: 'flex',
        flexDirection: 'column',
        alignItems: position === 'left' ? 'flex-start' : 'flex-end',
        gap: 12,
      }}
    >
      {/* 展开状态 - 显示二维码卡片 */}
      {expanded && (
        <div
          style={{
            background: '#fff',
            borderRadius: 12,
            padding: 16,
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e5e7eb',
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            minWidth: 140,
          }}
        >
          {/* 关闭按钮 */}
          <div
            style={{
              position: 'absolute',
              top: 8,
              [position === 'left' ? 'right' : 'left']: 8,
              cursor: 'pointer',
              color: '#9ca3af',
              fontSize: 12,
              width: 20,
              height: 20,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              transition: 'all 0.2s',
            }}
            onClick={() => setExpanded(false)}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#f3f4f6';
              e.currentTarget.style.color = '#6b7280';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.color = '#9ca3af';
            }}
          >
            <CloseOutlined />
          </div>

          {/* 标题 */}
          <div style={{ textAlign: 'center', marginBottom: 4 }}>
            <WechatOutlined style={{ color: '#07c160', fontSize: 20, marginBottom: 4 }} />
            <Text style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151' }}>
              扫码加入内测
            </Text>
          </div>

          {/* 微信群二维码 */}
          {groupQrCode && (
            <div style={{ textAlign: 'center' }}>
              <Tooltip title="扫码加入微信群">
                <img
                  src={groupQrCode}
                  alt="微信群二维码"
                  style={{
                    width: 100,
                    height: 100,
                    borderRadius: 8,
                    border: '1px solid #e5e7eb',
                    objectFit: 'cover',
                    cursor: 'pointer',
                  }}
                />
              </Tooltip>
              <Text style={{ display: 'block', fontSize: 11, color: '#6b7280', marginTop: 4 }}>
                加入微信群
              </Text>
            </div>
          )}

          {/* 微信号二维码 */}
          {idQrCode && (
            <div style={{ textAlign: 'center' }}>
              <Tooltip title="扫码添加微信">
                <img
                  src={idQrCode}
                  alt="微信号二维码"
                  style={{
                    width: 100,
                    height: 100,
                    borderRadius: 8,
                    border: '1px solid #e5e7eb',
                    objectFit: 'cover',
                    cursor: 'pointer',
                  }}
                />
              </Tooltip>
              <Text style={{ display: 'block', fontSize: 11, color: '#6b7280', marginTop: 4 }}>
                添加微信
              </Text>
            </div>
          )}
        </div>
      )}

      {/* 收起状态 - 显示悬浮按钮 */}
      {!expanded && (
        <Tooltip title="扫码加入内测群">
          <div
            onClick={() => setExpanded(true)}
            style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              background: '#07c160',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(7, 193, 96, 0.3)',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.1)';
              e.currentTarget.style.boxShadow = '0 6px 16px rgba(7, 193, 96, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(7, 193, 96, 0.3)';
            }}
          >
            <WechatOutlined style={{ color: '#fff', fontSize: 24 }} />
          </div>
        </Tooltip>
      )}
    </div>
  );
}
